import {
  HHFormControlLabel,
  HHRadio,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { Controller, useFormContext } from 'react-hook-form';

import { CostShareSetupOptionType } from '../../../../types';
import { capitalizeFirstLetterAndSpaceSnakeString } from '../../../../utils/bills-utils';

export const CONTRACT_FORM_COST_SHARE_SETTINGS_GROUP_ID =
  'contract-form-cost-share-settings-group';

export interface CostShareSettingsProps {
  wholeFormDisabled: boolean;
  index: number;
  costShareSetupOptions: CostShareSetupOptionType;
}

const CostShareSettings = ({
  wholeFormDisabled,
  index = 0,
  costShareSetupOptions,
}: CostShareSettingsProps): JSX.Element => {
  const { control } = useFormContext();

  const deductionTimingOptions = costShareSetupOptions?.deductionTiming ?? [];
  const cadenceOptions = costShareSetupOptions?.cadence ?? [];

  return (
    <HHStack direction="row" paddingLeft={5} spacing={2}>
      <HHStack direction="column">
        <HHTypography hhVariant="caption" color="GrayText">
          Deduction Timing
        </HHTypography>
        <Controller
          control={control}
          name={`selectedPackages.${index}.deductionTiming`}
          render={({ field: { onChange, value } }): JSX.Element => (
            <>
              {deductionTimingOptions.map((option: string) => (
                <HHFormControlLabel
                  key={option}
                  label={capitalizeFirstLetterAndSpaceSnakeString(option)}
                  control={
                    <HHRadio
                      hhVariant="primary"
                      value={option}
                      checked={value === option}
                      onChange={(e): void => onChange(e.target.value)}
                      disabled={wholeFormDisabled}
                    />
                  }
                />
              ))}
            </>
          )}
        />
      </HHStack>
      <HHStack direction="column">
        <HHTypography hhVariant="caption" color="GrayText">
          Cadence
        </HHTypography>
        <Controller
          control={control}
          name={`selectedPackages.${index}.cadence`}
          render={({ field: { onChange, value } }): JSX.Element => (
            <>
              {cadenceOptions.map((option: string) => (
                <HHFormControlLabel
                  key={option}
                  label={capitalizeFirstLetterAndSpaceSnakeString(option)}
                  control={
                    <HHRadio
                      hhVariant="primary"
                      value={option}
                      checked={value === option}
                      onChange={(e): void => onChange(e.target.value)}
                      disabled={wholeFormDisabled}
                    />
                  }
                />
              ))}
            </>
          )}
        />
      </HHStack>
    </HHStack>
  );
};

export default CostShareSettings;
